<template>
  <div>
    <v-container class="d-flex justify-center align-center fill-height">
<v-card class="text-center pa-1" >
      <v-img

:src="require('@/assets/images/seo.gif')"   height="200"
 contain
></v-img>
<v-card-text style="    padding-right: 0px;
    padding-left: 0px;
">
        <v-row no-gutters>
        <!-- <v-col cols="12">
          <v-img :src="require('@/assets/images/seo.gif')" class="elevation-0" max-height="280"></v-img>
          </v-col>-->
       
          <v-col cols="12" sm="12" md="12"  style="    padding-right: 12px;
          padding-left: 12px;padding-top: 22px;">
            <v-text-field
              v-model="Settings.url"
              label="Base URL"
              placeholder="www.example.com"
              outlined
             @change="GetPrinters()"
              dense
            ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" style="    padding-right: 12px;
            padding-left: 12px;padding-top: 0px;">
            <v-text-field
            v-model="Settings.display_time"
              label="Display Time"
              placeholder="In Seconds ( 2 )"
              outlined
              dense
            ></v-text-field>
          </v-col>
 
          <v-col cols="12" sm="12" md="12" style="    padding-right: 12px;
          padding-left: 12px;padding-top: 0px;">
            <v-text-field
            v-model="Settings.printerurl"
              label="Printer URL"
              placeholder="www.example.com / 190.89.0.1.23"
              outlined
              dense
             
              @change="GetPrinters(Settings.printerurl)"
            ></v-text-field>
            <v-checkbox id="chk" style="margin-top:0px;padding-top:0px;font-size: 10px !important;" :small="true" label="Copy Base Url" @change="copyBaseUrl" v-model="isChecked" ></v-checkbox>
            </v-col>
           <v-col cols="12" sm="12" md="12" style="    padding-right: 12px;
           padding-left: 12px;padding-top: 0px;">
           <v-autocomplete
              v-model="Printer"
              :items ="PrinterOptions"
               outlined
              label="Select Printer"
              dense
              append-icon="mdi-magnify"
          ></v-autocomplete>
           </v-col>
            <v-col cols="12" sm="12" md="12" style="    padding-right: 12px;
            padding-left: 12px;padding-top: 0px;">
           <v-autocomplete
             v-model="BarcodeType"
             :items ="TypeOptions"
               outlined
              label="Barcode Type"
              dense
              append-icon="mdi-magnify"
          ></v-autocomplete>
           </v-col>
   
          <v-col cols="6" sm="6" md="6" hidden>

             <v-switch
             
              label="Show Cost"
              color="info"
              
            ></v-switch>
           
          </v-col>
          <v-col cols="6" sm="4" md="4" hidden>
            <v-switch
       
              label="Show Supplier"
              color="info"
      
              hide-details
            ></v-switch>
          
          </v-col>
           
          <v-col cols="12" class="text-center">
            <v-btn color="info" class="mr-6" @click="save_settings()">
              Save
            </v-btn>
          </v-col>
        </v-row>
        </v-card-text>
</v-card>
</v-container>

  </div>
</template>
<script>
 var isFlutter
    window.displayAlertDialog = function(value) {
        isFlutter = value;
        //alert('isnativeFlutter: ' + isFlutter);
        localStorage.setItem("IsNativeFlutterApp", true);
    }

import axios from "axios";
import Vue from "vue";
export default {
  data() {
    return {
      Settings: {
        url: "",
        printerurl:"",
        display_time: "",
        
      },
      Printer:"",
      PrinterOptions:[],
      BarcodeType:"",
      TypeOptions:['Item','Shelf','Mini'],
      isChecked:false,
   
    };
  },
  watch: {
  
  },

  mounted() {
           try {
                //window.FromJavascript.postMessage('isnativeFlutter');
                window.flutter_inappwebview.callHandler('FromJavascript', 'isnativeFlutter');
               // Code that may throw an error
              // For example, accessing a non-existent property
           } catch (error) {
           
                console.error('An error occurred:', error);
           }
    if (localStorage.getItem("BaseURL") !== null) {
      this.URL__ = localStorage.getItem("BaseURL")
      this.Settings.url = localStorage.getItem("BaseURL");
      this.Settings.printerurl = localStorage.getItem("Printerurl");
      this.Settings.display_time = localStorage.getItem("Display_time");
      this.Printer = localStorage.getItem("Printer");
      this.BarcodeType = localStorage.getItem("BarcodeType");
      if(this.URL__ === this.Settings.printerurl)
      {
         this.isChecked = true
      }
     // this.checkNative(this.Settings.url);
      this.GetPrinters(this.Settings.printerurl);
      // this.GetItems(this.Settings.url);
    }
     
  },
  methods:
  {
    dashboard()
    {
      this.Token = localStorage.getItem('Token')
      if (this.Token === "" || this.Token === null || this.Token === undefined ) 
       {
        this.$router.push("login");
       }
       else{
        this.$router.push("Dashboard");
       }
    },
    copyBaseUrl()
    {
        this.Settings.printerurl = this.Settings.url
    },
    save_settings() {
      
      localStorage.setItem("BaseURL", this.Settings.url);
      localStorage.setItem("Display_time", this.Settings.display_time);
      localStorage.setItem("Printerurl", this.Settings.printerurl);
      localStorage.setItem("BarcodeType", this.BarcodeType);
      localStorage.setItem("Printer", this.Printer);
     
    
      this.$router.push("/login");
    
    },
    GetPrinters()
    {
      axios
          .get(this.Settings.url + "/api/common/getprinterlist")
          .then(
            (response) => {
              this.PrinterOptions = response.data
            },
            (error) => {
              console.log("error" + error);
            }
          );
    }
  }

 
}
</script>
<style scoped>
.v-container {
  height: 100vh;
}
</style>

